import React from "react";
import TextField from "./TextField";

const TextAreaField = props => (
  <TextField
    multiline={true}
    {...props}
  />
);

export default TextAreaField;
